import { setTagList, selCurentTag } from "./tagSlice";
import loaderClient from "api/reduxLoaderApi";

const TAGS_BASE = "/v2/backoffice/tags";

export const getAllTags = () => async (dispatch) => {
  const client = loaderClient("get")(`${TAGS_BASE}?limit=all&sortBy=tag:asc`);
  const res = await client({})({});
  if (!res.message) return "";
  return dispatch(setTagList(res.message));
};

export const createTag = (data, callback = false) => async (dispatch) => {
  const client = loaderClient("post")(TAGS_BASE);
  const res = await client(data)({});
  if (!res.message) return "";
  dispatch(getAllTags());
  return callback && callback();
};

export const editTag = (data, callback = false) => async (
  dispatch,
  getState
) => {
  const tag = selCurentTag(getState());
  const client = loaderClient("patch")(`${TAGS_BASE}/${tag.id}`);
  const res = await client(data)({});
  if (!res.message) return "";
  dispatch(getAllTags());
  return callback && callback();
};

export const deleteTags = (id, callback = false) => async (dispatch) => {
  const client = loaderClient("delete")(`${TAGS_BASE}/${id}`);
  const res = await client({})({});
  if (res.error) return "";
  dispatch(getAllTags());
  return callback && callback();
};
